import { connect } from "react-redux";
import SmsTemplatesComponent from "../../Components/MailFlows/SmsTemplatesComponent";

const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
});

export default connect(mapStateToProps)(SmsTemplatesComponent);
